import { useQuery } from '@tanstack/react-query';

import { authenticationSession } from '@/lib/authentication-session';
import {
  AppConnectionWithoutSensitiveData,
  ListAppConnectionsRequestQuery,
} from '@activepieces/shared';

import { appConnectionsApi } from './app-connections-api';

export const appConnectionsHooks = {
  useConnections: (
    request: Omit<ListAppConnectionsRequestQuery, 'projectId'>,
    options?: { enabled?: boolean },
  ) => {
    const projectId = authenticationSession.getProjectId();
    return useQuery<AppConnectionWithoutSensitiveData[]>({
      queryKey: ['app-connections', request.pieceName],
      queryFn: async () => {
        const localConnections = await appConnectionsApi.list({
          ...request,
          projectId: projectId!,
        });
        return [...localConnections.data];
      },
      staleTime: 0,
      enabled: !!projectId && (options?.enabled ?? true),
    });
  },
};
